import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-feather';

export default class SharableRecordingLinkContainer extends React.Component {
  render() {
    const { modalView, mediaShareLink } = this.props;
    const containerStyle = classNames(
      'SharableRecordingLinkContainer',
      'mt-8',
      { 'SharableRecordingLinkContainer--modalView': modalView },
    );

    return (
      <div className={containerStyle}>
        <div className="d-f w-100p">
          <div className="pt-4 mr-8">
            {/* This 'Link' is a feather-icon and is not an anchor tag nor does it contain one */
            /* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link className="c-midnight-50" height={20} strokeWidth={2.5} />
          </div>
          <div className="w-100p">
            <input
              className="SharableRecordingLinkContainer-linkInput form-control h-30 w-100p fz-sm"
              defaultValue={mediaShareLink}
              aria-label={t('common.copy_link')}
              data-behavior="highlight_on_focus"
              readOnly
            />
          </div>
        </div>
      </div>
    );
  }
}
